import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const lang = {
  ...zhLocale,
  layoutHeader: {
    login: '登录',
    register: '注册',
    linkHome: '首页',
    linkEmploy: '就业',
    linkBusiness: '创业',
    linkTalentPool: '人才库',
    linkBothMeetRoom: '两岸人才会客厅',
    linkPolicyInfo: '资讯中心',
    linkContactUs: '联系我们'
  },
  login: {
    loginText: '欢迎登录！',
    title: '厦门市思明区台湾人才服务中心',
    loginText1: '个人登录',
    loginText2: '企业登录',
    placeholder1: '请输入账号',
    placeholder2: '请输入密码',
    placeholder3: '请输入验证码',
    placeholder4: '请输入密码',
    placeholder5: '请再次输入密码',
    loginButton: '登录',
    registerButton: '注册',
    noAccount: '没有账号？',
    register: '立即注册'
  },
  register: {
    // loginText: '欢迎登录！',
    title: '厦门市思明区台湾人才服务中心',
    registerText1: '个人注册',
    registerText2: '企业注册',
    placeholder1: '请输入账号',
    placeholder2: '请输入密码',
    placeholder3: '请再次输入密码',
    placeholder4: '请输入图形验证码',
    placeholder5: '请输入企业名称',
    placeholder6: '请输入企业邮箱',
    placeholder7: '请输入统一社会信用代码',
    placeholder8: '请上传营业执照',
    hasAccount: '已有账号？',
    returnLogin: '返回登录'
  },
  layoutFooter: {
    link: '友情链接',
    link1: '厦门市人力资源和社会保障局',
    link2: '台湾青年就业广场',
    link3: 'i人才',
    time: '工作时间',
    contact: '联系我们',
    tel: '市话: 0592-5808611',
    addressTitle: '通讯地址',
    address: '地址: 厦门市思明区龙山南路84号工业设计中心212室',
    title: '厦门市思明区台湾人才服务中心',
    unit: '主管单位：厦门市思明区人民政府台湾事务办公室',
    bottomText: '工业和信息化部备案号：',
    internetContentProvider: '闽ICP备2021012396号-1'
  },
  home: {
    introduceTitle: '厦门市思明区台湾人才服务中心简介',
    introduce:
      '厦门市思明区台湾人才服务中心是思明区人民政府与中国海峡人才市场共同组建，主要 为厦门市企事业单位与台湾人才提供“一条龙、一站式”的专业化人才综合服务平台，中心 秉持“人才服务·服务人才”的理念，致力于发挥思明区对台服务工作的示范、带动及辐射 作用，更好服务广大台湾人才和用人单位，为台湾人才在厦门思明区的生活、就业、创业等 方面提供坚实的支撑，打造两岸人才交流合作与发展的事业圈和朋友圈，共创两岸人才融合 发展的美好未来。服务内容：（一）提供“一条龙、一站式”的人才服务窗口中心为台湾各 类人才来厦创业就业实习提供政策咨询、对接和综合辅导服务。 （二）提供线上“直通车” 人才供需对接系统中心搭建全国首个针对台湾人才服务网站，充分利用新媒体矩阵全面立体 快捷的传播服务优势，为思明区用人单位和台湾人才之间搭建一个高效对接的互动平台，为 企事业单位和人才提供线上求职、招聘、人事代理、人才培训、政策咨询及招聘会等实用服 务。中心同步打造“厦门市思明区台湾人才服务中心”微信服务号为其提供就业资源对接、 就业辅导等“直通车”服务。 （三）提供专业化定制人才服务中心针对企事业单位和台湾人 才需求提供人才推荐、人才培训、职业生涯规划、...',
    infoTitle: '资讯中心',
    newsTitle: '信息中心'
  }
}

export default lang
